import { styled } from '@linaria/react';

export const BetOuterWrapper = styled.div`
  grid-area: bet-wrapper;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  margin: 8px 0;
`;

// Shared base styles for the bet container. BetWrapper renders an <a> (clickable match
// link); BetContent renders a <div> (non-clickable variant when match links are disabled).
// Kept as a plain string so Linaria inlines it into both at build time, avoiding drift.
const betContainerStyles = `
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
  grid-area: bet-wrapper;
  width: auto;
  padding: 0 8px 5px 0;
  color: inherit;
  width: 100%;

  @media (min-width: 768px) {
    padding-bottom: 0;
    min-width: unset;
    max-width: unset;
  }
`;

export const BetWrapper = styled.a`
  ${betContainerStyles}
  cursor: pointer;
  text-decoration: inherit;
`;

export const BetContent = styled.div`
  ${betContainerStyles}
`;
